"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var job_reference_service_1 = require("../job-reference.service");
var autocomplete_cell_component_1 = require("../../../shared/grid/autocomplete-cell.component");
var datepicker_cell_component_1 = require("../../../shared/grid/datepicker-cell.component");
var ag_grid_angular_1 = require("ag-grid-angular");
var material_1 = require("@angular/material");
var bulk_action_dialog_component_1 = require("../../../shared/grid/bulk-action-dialog.component");
var rxjs_1 = require("rxjs");
var select_all_header_component_1 = require("../../../shared/grid/select-all-header.component");
var job_reference_create_modal_component_1 = require("../job-reference-create-modal/job-reference-create-modal.component");
var operators_1 = require("rxjs/operators");
var preferences_1 = require("../../../shared/preferences/preferences");
var shortid = require("shortid");
var notifications_service_1 = require("../../../shared/notification/notifications.service");
var preferences_service_1 = require("../../../shared/preferences/preferences.service");
var lodash_1 = require("lodash");
var shared_1 = require("../../../shared");
var JobReferenceGridComponent = /** @class */ (function () {
    function JobReferenceGridComponent(jobReferenceService, bulkDeleteDialog, preferencesService, notificationsService, jobReferenceCreateModal, authenticationService, snackBar) {
        var _this = this;
        this.jobReferenceService = jobReferenceService;
        this.bulkDeleteDialog = bulkDeleteDialog;
        this.preferencesService = preferencesService;
        this.notificationsService = notificationsService;
        this.jobReferenceCreateModal = jobReferenceCreateModal;
        this.authenticationService = authenticationService;
        this.snackBar = snackBar;
        this.frameworkComponents = {
            autocompleteCell: autocomplete_cell_component_1.AutocompleteCell,
            datepickerCell: datepicker_cell_component_1.DatepickerCell,
            selectAllHeader: select_all_header_component_1.SelectAllHeader,
            customNoRowsOverlay: shared_1.NoResultsComponent,
        };
        this.noRowsOverlayComponent = 'customNoRowsOverlay';
        this.noRowsOverlayComponentParams = {
            type: 'job references',
            onClick: function () { return _this.onAddJobClick(); },
        };
        this.sideBar = {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel'
                },
                {
                    id: 'filters',
                    labelDefault: 'Filters',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                },
            ]
        };
        this.columnDefs = [
            {
                headerName: 'Select All',
                field: 'select',
                headerComponent: 'selectAllHeader',
                pinned: 'left',
                width: 70,
                editable: false,
                checkboxSelection: true,
                headerComponentParams: {
                    checkboxSelection: true,
                    service: this.jobReferenceService,
                    selected: this.jobReferenceService.allSelected
                }
            },
            {
                headerName: 'Job Code',
                field: 'jobCode',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('jobCode').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Job Name',
                field: 'jobName',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('jobName').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Material',
                field: 'material',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('material').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Origin',
                field: 'origin',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('origin').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Destination',
                field: 'destination',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('destination').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Invoice Rate',
                field: 'invoiceRate',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('invoiceRate').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Haul Rate',
                field: 'haulRate',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('haulRate').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
            {
                headerName: 'Order Number',
                field: 'orderNumber',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        _this.jobReferenceService.getValuesForFieldQuery('orderNumber').subscribe(function (fields) {
                            fields.push('-- Blank --');
                            params.success(fields);
                        });
                    },
                    newRowsAction: 'keep',
                },
                editable: true,
                cellEditor: 'autocompleteCell',
                cellEditorParams: {
                    service: this.jobReferenceService,
                },
                onCellValueChanged: function (e) { return _this.onCellValueChanged(e); },
            },
        ];
        this.rowModelType = 'serverSide';
        this.cacheBlockSize = 100;
        this.maxBlocksInCache = 10;
        this.loading = false;
        this.search = '';
        this.searchChanged = new rxjs_1.Subject();
        this.user = this.authenticationService.user();
        this.searchChanged.pipe(operators_1.debounceTime(300), operators_1.distinctUntilChanged()).subscribe(function (search) {
            _this.search = search;
            _this.jobReferenceService.search = _this.search;
            _this.refreshTable();
        });
    }
    JobReferenceGridComponent.prototype.getContextMenuItems = function (params) {
        var _this = this;
        return [
            {
                name: 'Delete',
                action: function () { return _this.onDeleteJobReference(params); }
            },
            {
                name: 'Export',
                subMenu: [
                    {
                        name: 'Export Selected',
                        action: function () { return _this.onExportSelected(params); },
                    },
                    {
                        name: 'Export All',
                        action: function () { return _this.onExportAll(); },
                    },
                ]
            },
        ];
    };
    JobReferenceGridComponent.prototype.openSnackBar = function (message, action) {
        this.snackBar.open(message, action, { duration: 5000 });
    };
    JobReferenceGridComponent.prototype.onDeleteJobReference = function (params) {
        var _this = this;
        if (!params.api) {
            return;
        }
        var selected = params.api.getSelectedRows();
        if (!selected || !selected.length) {
            selected = [params.node.data];
            params.node.setSelected(true);
        }
        var dialog = this.bulkDeleteDialog.open(bulk_action_dialog_component_1.BulkActionDialogComponent, {
            width: '500px',
            data: {
                selected: selected,
                type: 'Job Reference',
            },
        });
        dialog.componentInstance.callback = function () {
            var jobs = rxjs_1.zip.apply(void 0, selected.map(function (j) {
                return _this.deleteJobReference(j);
            }));
            jobs.subscribe(function () {
                _this.refreshTable(true);
            });
        };
    };
    JobReferenceGridComponent.prototype.deleteJobReference = function (job) {
        return this.jobReferenceService.remove(job);
    };
    JobReferenceGridComponent.prototype.refreshTable = function (clear) {
        if (clear === void 0) { clear = false; }
        if (clear) {
            this.gridApi.deselectAll();
            this.gridApi.clearRangeSelection();
        }
        this.gridApi.refreshCells();
        this.gridApi.purgeServerSideCache();
    };
    JobReferenceGridComponent.prototype.onCellValueChanged = function (e) {
        var job = __assign({}, e.data);
        delete job.classes;
        delete job.createdAt;
        delete job.loading;
        delete job.selected;
        this.jobReferenceService.save(job).subscribe();
    };
    JobReferenceGridComponent.prototype.onGridReady = function (e) {
        var _this = this;
        if (!e.columnApi || !e.api) {
            return;
        }
        this.columnApi = e.columnApi;
        this.gridApi = e.api;
        this.applyPreferences();
        this.jobsGrid.gridOptions.getContextMenuItems = function (params) { return _this.getContextMenuItems(params); };
        e.api.setServerSideDatasource(this.jobReferenceService);
    };
    JobReferenceGridComponent.prototype.onFirstDataRendered = function () {
        this.autoSizeAll();
    };
    JobReferenceGridComponent.prototype.autoSizeAll = function () {
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.getColId());
        });
        this.columnApi.autoSizeColumns(allColumnIds);
    };
    JobReferenceGridComponent.prototype.onAddJobClick = function () {
        var _this = this;
        var dialog = this.jobReferenceCreateModal.open(job_reference_create_modal_component_1.JobReferenceCreateModalComponent, {
            width: '500px',
        });
        dialog.componentInstance.callback = function (response$) {
            response$.subscribe(function () { return _this.refreshTable(); });
        };
    };
    JobReferenceGridComponent.prototype.changeSearch = function (term) {
        this.searchChanged.next(term);
    };
    JobReferenceGridComponent.prototype.onExportSelected = function (params) {
        var _this = this;
        var selected;
        selected = params.api ?
            params.api.getSelectedRows().map(function (s) { return s.id; }) :
            params.map(function (s) { return s.id; });
        if ((!selected || !selected.length) && params.node && params.node.data) {
            selected = [params.node.data.id];
            params.node.setSelected(true);
        }
        this.jobReferenceService.exportGrid('jobs', selected).subscribe(function () { }, function (error) {
            var notification = {
                context: {
                    error: error,
                },
                id: shortid.generate(),
                message: 'An error occured exporting your data.',
                originator: 'tickets',
                type: notifications_service_1.NotificationType.Danger,
            };
            _this.notificationsService.addNotification(notification);
        });
    };
    JobReferenceGridComponent.prototype.onExportAll = function () {
        var _this = this;
        this.jobReferenceService.exportGrid('jobs').subscribe(function () { }, function (error) {
            var notification = {
                context: {
                    error: error,
                },
                id: shortid.generate(),
                message: 'An error occured exporting your data.',
                originator: 'tickets',
                type: notifications_service_1.NotificationType.Danger,
            };
            _this.notificationsService.addNotification(notification);
        });
    };
    JobReferenceGridComponent.prototype.applyPreferences = function () {
        var _this = this;
        // Only update or create a default preference until UI for selection is in place
        this.preferencesService.list().pipe(operators_1.map(function (prefs) {
            var pref = prefs.find(function (p) { return p.name === 'jobreference-default'; });
            return pref ? pref : new preferences_1.Preferences;
        })).subscribe(function (preferences) {
            _this.preferences = preferences;
            if (preferences.type === 'jobreference' && preferences.blob) {
                _this.columnApi.setColumnState(preferences.blob.columnState);
                _this.gridApi.setSortModel(preferences.blob.sortState);
            }
            var eventList = [
                'gridColumnsChanged',
                'columnPinned',
                'columnVisible',
                'columnResized',
                'columnMoved'
            ];
            eventList.forEach(function (event) {
                _this.gridApi.addEventListener(event, lodash_1.debounce(function () { return _this.savePreferences(); }, 300));
            });
        }, function (error) {
            var notification = {
                context: {
                    error: error,
                },
                id: shortid.generate(),
                message: 'An error occured saving your preferences.',
                originator: 'jobreferences',
                type: notifications_service_1.NotificationType.Danger,
            };
            _this.notificationsService.addNotification(notification);
        });
    };
    JobReferenceGridComponent.prototype.savePreferences = function () {
        var _this = this;
        var columnData = this.columnApi.getColumnState();
        var preferencesObj = __assign({}, this.preferences, { profile: this.user.id, type: 'jobreference', name: 'jobreference-default', blob: {
                columnState: columnData,
            } });
        this.preferencesService.save(preferencesObj).subscribe(function () { }, function (error) {
            var notification = {
                context: {
                    error: error,
                },
                id: shortid.generate(),
                message: 'An error occured saving your preferences.',
                originator: 'jobreferences',
                type: notifications_service_1.NotificationType.Danger,
            };
            _this.notificationsService.addNotification(notification);
        });
    };
    return JobReferenceGridComponent;
}());
exports.JobReferenceGridComponent = JobReferenceGridComponent;
